import { Loader } from "@circle-react-shared/uikit/Loader";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface ProgressOverlayProps {
  progress: number;
}

export const ProgressOverlay = ({ progress }: ProgressOverlayProps) => (
  <div className="bg-primary/80 pointer-events-none absolute inset-0 flex flex-col items-center justify-center backdrop-blur-sm">
    <Loader center />
    <Typography variant="label-sm" color="primary">
      {progress
        ? t("tiptap.progress", { progress: progress.toFixed(0) })
        : t("tiptap.preparing")}
    </Typography>
  </div>
);
